import { ExportType } from 'app/constants/exportType'

export const getExportTypeByNumber = (type: number) => {
  let exportType = ExportType.None

  switch (type) {
    case 1:
      exportType = ExportType.PaymentSapExport
      break
    case 2:
      exportType = ExportType.PaymentMerinosoftExport
      break
    case 3:
      exportType = ExportType.PaymentMerinosoftWorkOverPlanExport
      break
    case 4:
      exportType = ExportType.ExportTimesheetToR2Payer
      break
    case 5:
      exportType = ExportType.ExportTimesheetToEnova
      break
    case 6:
      exportType = ExportType.ExportForeignWorkToEnova
      break
    case 7:
      exportType = ExportType.OptimaTimesheetExportCsv
      break
    case 8:
      exportType = ExportType.OptimaBasicTripsExportCsv
      break
    case 9:
      exportType = ExportType.SymfoniaTripsExport
      break
    case 10:
      exportType = ExportType.ExportDriversToExternalSystem
      break
    case 11:
      exportType = ExportType.ExportDriverFreeDays
      break
    case 12:
      exportType = ExportType.ExportFullTimesheetToEnova
      break
    case 13:
      exportType = ExportType.DriversListExport
      break
    case 14:
      exportType = ExportType.PretorExport
      break
    case 15:
      exportType = ExportType.ExportDriversToImi
      break
    case 16:
      exportType = ExportType.ExportForeignTripsToEnova
      break
    case 18:
      exportType = ExportType.SapPccXmlExport
      break
    case 19:
      exportType = ExportType.OptimaTimesheetAmountsExport
      break
    case 20:
      exportType = ExportType.ForeignAllowancesXlsxExport
      break
    case 21:
      exportType = ExportType.ForeignAllowancesOptimaExport
      break
    case 22:
      exportType = ExportType.OptimaFreeDaysExport
      break
    case 23:
      exportType = ExportType.ExportTimesheetToEnovaSecondVersion
      break
    case 24:
      exportType = ExportType.GratyfikantExport
      break
    case 25:
      exportType = ExportType.ExportTimesheetAmountsToR2Payer
      break
    case 26:
      exportType = ExportType.AbsenceExportToR2Payer
      break
    case 27:
      exportType = ExportType.UniversalTripPartAmountsExport
      break
    case 28:
      exportType = ExportType.SapTimesheetMabauExport
      break
    case 29:
      exportType = ExportType.SapTimesheetDaysMabauExport
      break
    case 30:
      exportType = ExportType.SapTimesheetScheduleMabauExport
      break
    case 31:
      exportType = ExportType.TripInvoiceExport
      break
    case 32:
      exportType = ExportType.ExportTimesheetV2ToR2Payer
      break
    case 33:
      exportType = ExportType.WaproGangSanitarityExport
      break
    case 34:
      exportType = ExportType.HomelandAllowancesOptimaExport
      break
    case 35:
      exportType = ExportType.BfmPayrollPreview
      break
  }

  return exportType
}

export const getExportNumberByType = (type: ExportType) => {
  let exportNumber = 0

  switch (type) {
    case ExportType.PaymentSapExport:
      exportNumber = 1
      break
    case ExportType.PaymentMerinosoftExport:
      exportNumber = 2
      break
    case ExportType.PaymentMerinosoftWorkOverPlanExport:
      exportNumber = 3
      break
    case ExportType.ExportTimesheetToR2Payer:
      exportNumber = 4
      break
    case ExportType.ExportTimesheetToEnova:
      exportNumber = 5
      break
    case ExportType.ExportForeignWorkToEnova:
      exportNumber = 6
      break
    case ExportType.OptimaTimesheetExportCsv:
      exportNumber = 7
      break
    case ExportType.OptimaBasicTripsExportCsv:
      exportNumber = 8
      break
    case ExportType.SymfoniaTripsExport:
      exportNumber = 9
      break
    case ExportType.ExportDriversToExternalSystem:
      exportNumber = 10
      break
    case ExportType.ExportDriverFreeDays:
      exportNumber = 11
      break
    case ExportType.ExportFullTimesheetToEnova:
      exportNumber = 12
      break
    case ExportType.DriversListExport:
      exportNumber = 13
      break
    case ExportType.PretorExport:
      exportNumber = 14
      break
    case ExportType.ExportDriversToImi:
      exportNumber = 15
      break
    case ExportType.ExportForeignTripsToEnova:
      exportNumber = 16
      break
    case ExportType.SapPccXmlExport:
      exportNumber = 18
      break
    case ExportType.OptimaTimesheetAmountsExport:
      exportNumber = 19
      break
    case ExportType.ForeignAllowancesXlsxExport:
      exportNumber = 20
      break
    case ExportType.ForeignAllowancesOptimaExport:
      exportNumber = 21
      break
    case ExportType.OptimaFreeDaysExport:
      exportNumber = 22
      break
    case ExportType.ExportTimesheetToEnovaSecondVersion:
      exportNumber = 23
      break
    case ExportType.GratyfikantExport:
      exportNumber = 24
      break
    case ExportType.ExportTimesheetAmountsToR2Payer:
      exportNumber = 25
      break
    case ExportType.AbsenceExportToR2Payer:
      exportNumber = 26
      break
    case ExportType.UniversalTripPartAmountsExport:
      exportNumber = 27
      break
    case ExportType.SapTimesheetMabauExport:
      exportNumber = 28
      break
    case ExportType.SapTimesheetDaysMabauExport:
      exportNumber = 29
      break
    case ExportType.SapTimesheetScheduleMabauExport:
      exportNumber = 30
      break
    case ExportType.TripInvoiceExport:
      exportNumber = 31
      break
    case ExportType.ExportTimesheetV2ToR2Payer:
      exportNumber = 32
      break
    case ExportType.WaproGangSanitarityExport:
      exportNumber = 33
      break
    case ExportType.HomelandAllowancesOptimaExport:
      exportNumber = 34
      break
    case ExportType.BfmPayrollPreview:
      exportNumber = 35
      break
  }

  return exportNumber
}
